import React from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {Text} from '@priority-software/priority-style-react';
import classNames from 'classnames';
import texts from '../../texts';
import styles from '../styles/historyHeader.module.scss';
import {Form} from '../../../../../../stores/Form';
import {monitorAction} from '../../Common/actions';
import {MonitoredActions} from '../../Common/consts';
import {createDataTestId} from '../../../../../../utils/dataTestId';

type Props = {
    form: Form;
    isLoading: boolean;
    statusesSubformName: string;
    changesSubformName: string;
    switchSubform: (subformType: priority.netitems.form.SubformType) => void;
};

export const HistoryTabs = ({
    form,
    isLoading,
    statusesSubformName,
    changesSubformName,
    switchSubform
}: Props) => {
    const toggleTab = (subformType: priority.netitems.form.SubformType, subformName: string) => {
        if (isLoading) {
            return;
        }
        monitorAction({
            subformType,
            action: MonitoredActions.Toggle,
            subformName
        });
        switchSubform(subformType);
    };

    return (
        <div className={styles.historyTabs} {...createDataTestId(`tabs-container`, false)}>
            {statusesSubformName && (
                <Text
                    skin={'paragraph-2'}
                    componentClasses={classNames(styles.tab, {
                        [styles.activeTab]: form?.ename === statusesSubformName
                    })}
                    onClick={() =>
                        toggleTab(priority.netitems.form.SubformType.StatusLog, statusesSubformName)
                    }
                >
                    {texts.statuses}
                </Text>
            )}
            {changesSubformName && (
                <Text
                    skin={'paragraph-2'}
                    componentClasses={classNames(styles.tab, {
                        [styles.activeTab]: form?.ename === changesSubformName
                    })}
                    onClick={() =>
                        toggleTab(priority.netitems.form.SubformType.ChangeLog, changesSubformName)
                    }
                >
                    {texts.changes}
                </Text>
            )}
        </div>
    );
};
